/* Pelletexpert – gedeelde scripts. Wordt door meerdere secties geladen, draait maar één keer. */
(function () {
  if (window.__peInit) return;
  window.__peInit = true;
  document.documentElement.classList.add('pe-js');

  /* ---------- Tracking (GA4 / Google Tag Manager) ---------- */
  function track(name, params) {
    params = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) {}
  }
  window.peTrack = track;

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-pe-track]');
    if (!el) return;
    track(el.getAttribute('data-pe-track'), { plek: el.getAttribute('data-pe-plek') || '' });
  });

  /* ---------- Opslag van postcode (tussen pagina's) ---------- */
  function bewaar(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function lees(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }

  /* ---------- Postcodelijst uit data-attribuut ---------- */
  function parseLijst(tekst) {
    var map = {};
    (tekst || '').split(/\r?\n/).forEach(function (regel) {
      var d = regel.split('=');
      var pc = (d[0] || '').trim();
      if (/^\d{4}$/.test(pc)) map[pc] = (d[1] || '').trim();
    });
    return map;
  }

  function vulFormulierPostcode(pc) {
    document.querySelectorAll('[data-pe-postcode-veld]').forEach(function (inp) {
      if (!inp.value) { inp.value = pc; inp.dispatchEvent(new Event('input')); }
    });
  }

  function initPostcode(root) {
    var map = parseLijst(root.getAttribute('data-lijst'));
    var form = root.querySelector('form');
    var input = root.querySelector('.pe-postcode__input');
    var uit = root.querySelector('.pe-postcode__resultaat');
    var okTekst = root.getAttribute('data-ok') || 'Ja, wij komen bij u in [gemeente].';
    var neeTekst = root.getAttribute('data-nee') || '';
    var anker = root.getAttribute('data-anker') || '#pe-aanvraag';
    var buiten = root.querySelector('#pe-buiten-form');

    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 4); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = input.value.trim();
      uit.innerHTML = '';
      if (!/^\d{4}$/.test(pc)) {
        uit.innerHTML = '<div class="pe-melding pe-melding--fout">Vul een Belgische postcode van 4 cijfers in.</div>';
        input.focus();
        return;
      }
      bewaar('pe_postcode', pc);
      vulFormulierPostcode(pc);
      var div = document.createElement('div');
      var knop = document.createElement('a');
      knop.className = 'pe-btn pe-btn--primair';
      knop.href = anker;
      knop.setAttribute('data-pe-track', 'klik_aanvraag');
      knop.setAttribute('data-pe-plek', 'postcodecheck');
      if (Object.prototype.hasOwnProperty.call(map, pc)) {
        var gem = map[pc] || 'uw gemeente';
        div.className = 'pe-postcode__ok';
        var p = document.createElement('p');
        var s = document.createElement('strong');
        s.textContent = okTekst.replace('[gemeente]', gem);
        p.appendChild(s);
        div.appendChild(p);
        knop.textContent = 'Plan uw afspraak';
        div.appendChild(knop);
        track('postcode_check', { resultaat: 'in_werkgebied', postcode: pc });
      } else {
        div.className = 'pe-postcode__nee';
        var p2 = document.createElement('p');
        p2.textContent = neeTekst;
        div.appendChild(p2);
        track('postcode_check', { resultaat: 'buiten_werkgebied', postcode: pc });
      }
      uit.appendChild(div);
      if (buiten) {
        var erbuiten = !Object.prototype.hasOwnProperty.call(map, pc);
        buiten.classList.toggle('is-open', erbuiten);
        if (erbuiten) {
          var bpc = buiten.querySelector('[data-pe-buiten-pc]');
          if (bpc) bpc.value = pc;
          var eerste = buiten.querySelector('select');
          if (eerste) eerste.focus();
        }
      }
    });
  }

  /* ---------- Stappenformulier ---------- */
  function initAanvraag(root) {
    var map = parseLijst(root.getAttribute('data-lijst'));
    var stappen = Array.prototype.slice.call(root.querySelectorAll('.pe-stap'));
    var balkjes = root.querySelectorAll('.pe-voortgang span');
    var vorige = root.querySelector('[data-pe-vorige]');
    var volgende = root.querySelector('[data-pe-volgende]');
    var verzend = root.querySelector('[data-pe-verzend]');
    var fout = root.querySelector('[data-pe-fout]');
    var huidig = 0;
    var gestart = false;
    var prob = root.querySelector('[data-pe-probleem]');
    var probOptioneel = root.querySelector('[data-pe-prob-optioneel]');
    var foutcodeVeld = root.querySelector('[data-pe-foutcode]');
    var TYPE_STORING = 'Herstelling of storing';

    // Probleembeschrijving is enkel verplicht bij een herstelling of storing
    function updateProbleemVerplicht() {
      if (!prob) return;
      var gekozen = root.querySelector('input[name="contact[Type aanvraag]"]:checked');
      var verplicht = !!gekozen && gekozen.value === TYPE_STORING;
      prob.required = verplicht;
      if (probOptioneel) probOptioneel.hidden = verplicht;
    }
    root.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'contact[Type aanvraag]') updateProbleemVerplicht();
    });

    function toon(i) {
      huidig = i;
      stappen.forEach(function (s, n) { s.classList.toggle('is-actief', n === i); });
      balkjes.forEach(function (b, n) { b.classList.toggle('is-actief', n <= i); });
      vorige.style.visibility = i === 0 ? 'hidden' : 'visible';
      var laatste = i === stappen.length - 1;
      volgende.style.display = laatste ? 'none' : '';
      verzend.style.display = laatste ? '' : 'none';
      fout.textContent = '';
      fout.hidden = true;
    }

    function stapGeldig(s) {
      updateProbleemVerplicht();
      var velden = s.querySelectorAll('input, select, textarea');
      for (var i = 0; i < velden.length; i++) {
        if (!velden[i].checkValidity()) {
          fout.textContent = velden[i].type === 'radio' ? 'Maak een keuze om verder te gaan.' : (velden[i].getAttribute('data-fout') || 'Vul dit veld in om verder te gaan.');
          fout.hidden = false;
          if (velden[i].type !== 'radio') velden[i].focus();
          return false;
        }
      }
      return true;
    }

    volgende.addEventListener('click', function () {
      if (!stapGeldig(stappen[huidig])) return;
      if (!gestart) { gestart = true; track('aanvraag_gestart'); }
      toon(huidig + 1);
      var legend = stappen[huidig].querySelector('legend');
      if (legend) { legend.setAttribute('tabindex', '-1'); legend.focus(); }
    });
    vorige.addEventListener('click', function () { if (huidig > 0) toon(huidig - 1); });

    (root.closest('form') || root.querySelector('form')).addEventListener('submit', function (e) {
      for (var i = 0; i < stappen.length; i++) {
        if (!stapGeldig(stappen[i])) { e.preventDefault(); toon(i); stapGeldig(stappen[i]); return; }
      }
      bewaar('pe_aanvraag_verstuurd', '1');
    });

    // Postcode-feedback in het formulier
    var pcVeld = root.querySelector('[data-pe-postcode-veld]');
    var pcInfo = root.querySelector('[data-pe-postcode-info]');
    var gemVeld = root.querySelector('[data-pe-gemeente-veld]');
    var wgVeld = root.querySelector('[data-pe-werkgebied]');
    if (pcVeld) {
      pcVeld.addEventListener('input', function () {
        pcVeld.value = pcVeld.value.replace(/\D/g, '').slice(0, 4);
        var pc = pcVeld.value;
        pcInfo.hidden = true;
        if (pc.length === 4) {
          pcInfo.hidden = false;
          if (Object.prototype.hasOwnProperty.call(map, pc)) {
            pcInfo.className = 'pe-melding pe-melding--ok';
            pcInfo.textContent = 'Top, ' + (map[pc] || 'uw gemeente') + ' ligt in ons werkgebied.';
            if (gemVeld && !gemVeld.value && map[pc]) gemVeld.value = map[pc];
            if (wgVeld) wgVeld.value = 'Ja (' + (map[pc] || pc) + ')';
          } else {
            pcInfo.className = 'pe-melding pe-melding--info';
            pcInfo.textContent = 'Deze postcode valt buiten ons vaste werkgebied. Vraag het gerust aan: zijn wij binnenkort in uw buurt, dan nemen we contact op.';
            if (wgVeld) wgVeld.value = 'BUITEN WERKGEBIED (' + pc + ')';
          }
        }
      });
      var bewaard = lees('pe_postcode');
      if (bewaard && !pcVeld.value) { pcVeld.value = bewaard; pcVeld.dispatchEvent(new Event('input')); }
    }

    // Voorkeuze via links met data-pe-type (bv. vanuit abonnement of foutcode)
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-pe-type]');
      if (!el) return;
      var radio = root.querySelector('input[name="contact[Type aanvraag]"][value="' + el.getAttribute('data-pe-type') + '"]');
      if (radio) radio.checked = true;
      updateProbleemVerplicht();
      var code = el.getAttribute('data-pe-code');
      if (code && foutcodeVeld) { if (!foutcodeVeld.value) foutcodeVeld.value = code; }
      else if (code && prob && !prob.value) prob.value = 'Foutcode ' + code + ': ';
      var merk = el.getAttribute('data-pe-merk');
      if (merk) {
        var mr = root.querySelector('input[name="contact[Merk kachel]"][value="' + merk + '"]');
        if (mr) mr.checked = true;
      }
    });

    updateProbleemVerplicht();
    toon(0);
  }

  /* ---------- Foutcodezoeker ---------- */
  function initFoutcodes(root) {
    var merkSel = root.querySelector('[data-pe-merk-filter]');
    var zoek = root.querySelector('[data-pe-zoek]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.pe-code'));
    var leeg = root.querySelector('[data-pe-leeg]');
    var timer;

    function filter() {
      var m = merkSel.value.toLowerCase();
      var q = zoek.value.trim().toLowerCase();
      var zichtbaar = 0;
      items.forEach(function (it) {
        var okMerk = !m || it.getAttribute('data-merk').toLowerCase() === m;
        var okZoek = !q || it.textContent.toLowerCase().indexOf(q) > -1;
        var toon = okMerk && okZoek;
        it.hidden = !toon;
        if (toon) zichtbaar++;
      });
      leeg.hidden = zichtbaar > 0;
      if (zichtbaar === 1 && q) { items.filter(function (i) { return !i.hidden; })[0].open = true; }
      clearTimeout(timer);
      if (q) timer = setTimeout(function () { track('foutcode_zoek', { merk: m, zoekterm: q, resultaten: zichtbaar }); }, 800);
    }
    merkSel.addEventListener('change', filter);
    zoek.addEventListener('input', filter);
    root.addEventListener('toggle', function (e) {
      if (e.target.classList && e.target.classList.contains('pe-code') && e.target.open) {
        track('foutcode_open', { code: e.target.getAttribute('data-code'), merk: e.target.getAttribute('data-merk') });
      }
    }, true);
  }

  /* ---------- Bevestiging na verzenden (juiste formulier tonen) ---------- */
  function initSucces() {
    var hash = (location.hash || '').replace('#', '');
    var gepost = /contact_posted=true/.test(location.search);
    var laatst = lees('pe_laatst_form');
    document.querySelectorAll('form[id]').forEach(function (f) {
      var succes = f.querySelector('[data-pe-succes]');
      var fouten = f.querySelector('[data-pe-fouten]');
      var dezeForm = hash && document.getElementById(hash) ? hash === f.id : laatst === f.id;
      if (fouten && !dezeForm) fouten.hidden = true;
      if (f.id === 'ContactForm' && !dezeForm && document.getElementById('pe-aanvraag-form')) {
        f.querySelectorAll('.form__message, .form-status-list').forEach(function (m) { m.hidden = true; m.style.display = 'none'; });
      }
      if (fouten && dezeForm && f.id === 'pe-buiten-form') f.classList.add('is-open');
      if (succes && dezeForm && gepost) {
        succes.hidden = false;
        var inhoud = f.querySelector('[data-pe-inhoud]');
        if (inhoud) inhoud.hidden = true;
        f.classList.add('is-open');
        track('generate_lead', { formulier: f.id === 'pe-buiten-form' ? 'buiten_werkgebied' : 'aanvraag' });
        setTimeout(function () { f.scrollIntoView({ block: 'center' }); }, 50);
      }
    });
  }

  /* ---------- Links naar het formulier: op pagina's met formulier lokaal springen ---------- */
  function initAanvraagLinks() {
    var heeftFormulier = !!document.getElementById('pe-aanvraag');
    document.querySelectorAll('a[href="/#pe-aanvraag"], a[data-pe-afspraak]').forEach(function (a) {
      if (heeftFormulier) a.setAttribute('href', '#pe-aanvraag');
      else if (a.getAttribute('href') === '#pe-aanvraag') a.setAttribute('href', '/#pe-aanvraag');
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pe-postcodecheck]').forEach(function (r) { if (!r.__pe) { r.__pe = 1; initPostcode(r); } });
    (scope || document).querySelectorAll('[data-pe-aanvraag]').forEach(function (r) { if (!r.__pe) { r.__pe = 1; initAanvraag(r); } });
    (scope || document).querySelectorAll('[data-pe-foutcodes]').forEach(function (r) { if (!r.__pe) { r.__pe = 1; initFoutcodes(r); } });
    if (document.querySelector('.pe-balk')) document.body.classList.add('pe-heeft-balk');
    initAanvraagLinks();
  }

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id && !e.defaultPrevented) bewaar('pe_laatst_form', e.target.id);
  });

  function start() { init(); initSucces(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Live bijwerken in de Shopify-thema-editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
